import { render, staticRenderFns } from "./SystemNotifications.vue?vue&type=template&id=35dfeb40&scoped=true&"
import script from "./SystemNotifications.vue?vue&type=script&lang=js&"
export * from "./SystemNotifications.vue?vue&type=script&lang=js&"
import style0 from "./SystemNotifications.vue?vue&type=style&index=0&id=35dfeb40&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dfeb40",
  null
  
)

export default component.exports